import React from 'react';
import { Steps, Result, Button } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useStoreState, store, useStoreActions } from '../store';
import { Link } from 'react-router-dom';
import { push } from 'redux-first-history';
import { ForgotPasswordForm } from '../components/account/ForgotPasswordForm';
import { LocalizedText } from '../components/i18n/LocalizedText';
import { UnauthenticatedLayout } from '../layout/UnauthenticatedLayout';

const { Step } = Steps;

export const ForgotPassword = () => {
  const passwordResetSubmitted = useStoreState((state) => state.session.passwordResetSubmitted);
  const setPasswordResetSubmittedFlag = useStoreActions((actions) => actions.session.setPasswordResetSubmittedFlag);

  const steps = passwordResetSubmitted ? null : (
    <Steps size="small">
      <Step title={<LocalizedText token="registration.resetPassword" />} icon={<UserOutlined />} />
    </Steps>
  );

  const cardActions = passwordResetSubmitted
    ? []
    : [
        <Link to="/login">
          <LocalizedText token="registration.returnToLogin" />
        </Link>,
      ];

  const getWorkflowStep = () => {
    const redirectToPath = (redirectPath: string) => store.dispatch(push(redirectPath));
    const postSubmitLogin = () => {
      setPasswordResetSubmittedFlag(false);
      redirectToPath('/login');
    };
    switch (passwordResetSubmitted) {
      case true:
        return (
          <Result
            status="success"
            title={<LocalizedText token="registration.resetPassword" />}
            subTitle={<LocalizedText token="registration.passwordResetEmailSent" />}
            extra={[
              <Button type="primary" key="console" onClick={postSubmitLogin}>
                <LocalizedText token="common.login" />
              </Button>,
            ]}
          />
        );
      default:
        return <ForgotPasswordForm />;
    }
  };

  return (
    <UnauthenticatedLayout title={steps} actions={cardActions}>
      {getWorkflowStep()}
    </UnauthenticatedLayout>
  );
};

export default ForgotPassword;
